import type { Category } from '@/types/product';

const createCollectionLink = (collection: string, path: string): string => {
  return `/collections/${collection}/${path}/`;
};

const moisturizerSubCategories = [
  { name: 'Toner', path: 'toner' },
  { name: 'Lotion', path: 'lotion' },
  { name: 'Essence & Serum', path: 'essence-serum-ampoule' },
  { name: 'Mist', path: 'mist' },
  { name: 'Oil', path: 'oil' },
  { name: 'Gel', path: 'gel' },
  { name: 'Cream', path: 'cream' },
  { name: 'Facial Cream', path: 'cream/facial-cream' },
  { name: 'Eye & Neck Cream', path: 'cream/eye-neck-cream' },
  { name: 'Multi-Balm & Stick', path: 'cream/multi-balm-stick' },
];

const cleanserSubCategories = [
  { name: 'Cleansing Foam', path: 'cleansing-foam' },
  { name: 'Cleansing Gel & Powder', path: 'cleansing-gel-powder' },
  { name: 'Cleansing Soap', path: 'cleansing-soap' },
  { name: 'Cleansing Oil', path: 'cleansing-oil' },
  { name: 'Cleansing Water', path: 'cleansing-water' },
  { name: 'Lip & Eye Remover', path: 'lip-eye-remover' },
  { name: 'Cleansing Wipes & Sheets', path: 'cleansing-wipes-sheets' },
  { name: 'Cleansing Lotion & Cream', path: 'cleansing-lotion-cream' },
  { name: 'Scrub & Peeling', path: 'scrub-peeling' },
  { name: '  Gel & Gommage', path: 'scrub-peeling/gel-gommage-cream-scrub-peeling' },
  { name: '  Peeling Toner & Cotton Swab', path: 'scrub-peeling/peeling-toner-cotton-swab' },
  { name: '  Peeling Pad', path: 'scrub-peeling/peeling-pad' },
  { name: '  Powder & Scrub', path: 'scrub-peeling/powder-scrub' },
];

const maskSubCategories = [
  { name: 'Sheet Mask', path: 'sheet-mask' },
  { name: 'Wash-Off Mask', path: 'wash-off-mask' },
  { name: 'Peel-Off Mask', path: 'peel-off-mask' },
  { name: 'Sleeping Mask', path: 'sleeping-mask' },
  { name: 'Rubber & Modeling Mask', path: 'rubber-modeling-mask' },
  { name: 'Toner Pads', path: 'toner-pads' },
  { name: 'Nose Patch', path: 'nose-patch' },
  { name: 'Spot Patch', path: 'spot-patch' },
  { name: 'Eye Patch', path: 'eye-patch' },
];

const sunCareSubCategories = [
  { name: 'Sun Screen', path: 'sun-screen' },
  { name: 'Sun Stick', path: 'sun-stick' },
  { name: 'Sun Cushion & Sun Compact', path: 'sun-cushion-sun-compact' },
];

const specialCategories = [
  { name: 'Best Sellers', link: '/shop/?orderby=score' },
  { name: 'Trend', link: '/trend/' },
];

const mapSubCategories = (subCategories: Array<{ name: string; path: string }>, collection: string) => {
  return subCategories.map(({ name, path }) => ({
    name,
    link: createCollectionLink(collection, path),
  }));
};

export const categories: Category[] = [
  {
    id: 1,
    category: 'Moisturizer',
    subCategories: mapSubCategories(moisturizerSubCategories, 'moisturizer'),
  },
  {
    id: 2,
    category: 'Cleanser',
    subCategories: mapSubCategories(cleanserSubCategories, 'cleanser'),
  },
  {
    id: 3,
    category: 'Mask',
    subCategories: mapSubCategories(maskSubCategories, 'mask-pack'),
  },
  {
    id: 4,
    category: 'Sun Care',
    subCategories: mapSubCategories(sunCareSubCategories, 'sun-care'),
  },
  {
    id: 5,
    category: 'Shop All',
    subCategories: specialCategories,
  },
];
